export const BUNDLE_YEARLY_DISCOUNT = 10
